module.exports = __webpack_public_path__ + "static/TheMetSans-Light-b6d6e684a37ed9860493c24d2da7469d.woff2";